// Localização: frontend/src/components/UI/Alert.js (VERSÃO FINAL COM RESPONSIVIDADE)


import React from 'react';
import { CheckCircle, XCircle, AlertTriangle, Info, X } from 'lucide-react';

/**
 * Componente de Alerta Reutilizável (Alert.js)
 * * Exibe mensagens de feedback (sucesso, erro, aviso, info)
 * e permite que a mensagem seja fechada.
 * * @param {string} type - Tipo do alerta ('success', 'error', 'warning', 'info'). Padrão: 'info'.
 * @param {string} message - A mensagem a ser exibida.
 * @param {function} onClose - Função de callback para fechar o alerta (opcional).
 */
const Alert = ({ type = 'info', message, onClose }) => {
    if (!message) return null;

    // Define estilos e ícones baseados no tipo
    let classes = {};
    let IconComponent = Info;

    switch (type) {
        case 'success':
            classes = {
                container: 'bg-green-100 border-green-400 text-green-700',
                icon: 'text-green-500',
                closeButton: 'text-green-700 hover:bg-green-200'
            };
            IconComponent = CheckCircle;
            break;
        case 'error':
            classes = {
                container: 'bg-red-100 border-red-400 text-red-700',
                icon: 'text-red-500',
                closeButton: 'text-red-700 hover:bg-red-200'
            };
            IconComponent = XCircle;
            break;
        case 'warning':
            classes = {
                container: 'bg-yellow-100 border-yellow-400 text-yellow-700',
                icon: 'text-yellow-500',
                closeButton: 'text-yellow-700 hover:bg-yellow-200'
            };
            IconComponent = AlertTriangle;
            break;
        case 'info':
        default:
            classes = {
                container: 'bg-blue-100 border-blue-400 text-blue-700',
                icon: 'text-blue-500',
                closeButton: 'text-blue-700 hover:bg-blue-200'
            };
            IconComponent = Info;
            break;
    }

    return (
        <div className={`p-4 border-l-4 rounded-lg shadow-md ${classes.container} transition duration-300`} role="alert">
            <div className="flex items-center justify-between">
                
                {/* Ícone e Mensagem */}
                <div className="flex items-center flex-1 pr-4">
                    <IconComponent className={`w-5 h-5 mr-3 flex-shrink-0 ${classes.icon}`} />
                    <p className="font-medium text-sm">{message}</p>
                </div>

                {/* Botão de Fechar (se a função onClose for fornecida) */}
                {onClose && (
                    <button
                        onClick={onClose}
                        className={`p-1 rounded-full opacity-70 transition duration-150 ${classes.closeButton}`}
                        aria-label="Close"
                    >
                        <X className="w-4 h-4" />
                    </button>
                )}
            </div>
        </div>
    );
};

export default Alert;